// Genera un color por año (claro = más antiguo, oscuro = más reciente) con
// una paleta fija de 8 verdes, para que años consecutivos se distingan
// claramente. Reutilizado por ChartFamiliasRefacciones.js y ChartVentaMensual.js.
//
// Fecha de creación: 2026-07-21
// Autor: IA (Claude)
// Módulo funcional: Ventas / Reporte de Refacciones (helper compartido)
const PALETA_VERDES_POR_ANIO = [
    "#d9ead3", // 1 — verde más claro
    "#b6d7a8",
    "#93c47d",
    "#6aa84f",
    "#4d8c3f",
    "#367c2b", // 6 — $green (verde base del proyecto)
    "#255220", // 7 — $green-dark
    "#173614", // 8 — verde más oscuro
];

// `{ [anio]: colorHex }`, repartidos en la paleta según orden cronológico.
// Con más de 8 años, 2 podrían compartir tono.
export const construirColorPorAnio = (anios) => {
    const ordenados = [...anios].map(String).sort((a, b) => Number(a) - Number(b));
    const mapa = {};
    ordenados.forEach((anio, indice) => {
        const t = ordenados.length <= 1 ? 1 : indice / (ordenados.length - 1);
        const paletaIndice = Math.round(t * (PALETA_VERDES_POR_ANIO.length - 1));
        mapa[anio] = PALETA_VERDES_POR_ANIO[paletaIndice];
    });
    return mapa;
};
